import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConnectionService, ConnectionState } from 'ng-connection-service';
import { ConfirmationService } from 'primeng/api';
import { AgendasService } from '../../services/agendas.service';
import { MessageAlertService } from '@shared/views/_messagesService/_messageAlertServices';

@Component({
  selector: 'app-agenda-form',
  templateUrl: './agenda-form.component.html',
  styleUrls: ['./agenda-form.component.scss']
})
export class AgendaFormComponent implements OnInit {
  public formAgenda: FormGroup;
  agendaData: any;
  agenda: any = null;
  isOnline = true;
  submitted = false;
  enviandose = false;
  attachedFiles: any = {
    data: [],
    invalid: false,
    isEmpty: true,
    attachedFilesValidQuantity: 0
  };
  isAttachedFileRequire = false;
  currentPage: number;

  constructor(
    private route: Router,
    private router: ActivatedRoute,
    private formBuilder: FormBuilder,
    private confirmationService: ConfirmationService,
    private connectionService: ConnectionService,
    private agendasService: AgendasService,
    private messageAlertServices: MessageAlertService
  ) {
    this.agendasService.agendaData.subscribe(
      (agendaData) => (this.agendaData = agendaData)
    );
  }

  get f(): any {
    return this.formAgenda.controls;
  }

  async ngOnInit():Promise<void> {
    this.router.queryParams.subscribe(params => {
      const currentPage = +params['page'];
      if (!isNaN(currentPage)) {
        this.currentPage = currentPage;
      }
    });
    this.connectionService.monitor().subscribe((connected: ConnectionState) => {
      this.isOnline = connected.hasNetworkConnection;;
    })
    this.isOnline = JSON.parse(localStorage.getItem('isStillOnline'));

    this.cargarFormulario();
    await this.cargarData();
  }

  private async cargarData(): Promise<void> {
    this.agendasService.getSingleAgendaData(this.agendaData.idLote).subscribe(
      async (results) => {
        const finalRemapedData = { ...this.agendaData, ...results.response };
        this.agendaData = finalRemapedData;
        this.agenda = this.agendaData;

        this.setValuesOnForm();
      },
      async (error) => {
        console.log('ERROR ON GET SINGLE DATA al ingresar a agenda: ', error);
      }
    );
  }

  private cargarFormulario() {
    const fields = {
      contactoEmpresaNombre: [null, [Validators.required]],
      contactoEmpresaTelefono: [null, [Validators.required]],
      contactoEmpresaMail: [null, [Validators.required]],
      contactoEmpresaCargo: [null, [Validators.required]],
      responsableMedicoNombre: [null],
      responsableMedicoMatricula: [null],
      responsableMedicoTelefono: [null],
      responsableMedicoMail: [null],
    }
    this.formAgenda = this.formBuilder.group(fields);
  }

  private setValuesOnForm() : void{
    this.formAgenda.controls.contactoEmpresaNombre.setValue(this.agenda?.contactoEmpresaNombre);
    this.formAgenda.controls.contactoEmpresaTelefono.setValue(this.agenda?.contactoEmpresaTelefono);
    this.formAgenda.controls.contactoEmpresaMail.setValue(this.agenda?.contactoEmpresaMail);
    this.formAgenda.controls.contactoEmpresaCargo.setValue(this.agenda?.contactoEmpresaCargo);
    this.formAgenda.controls.responsableMedicoNombre.setValue(this.agenda?.responsableMedicoNombre);
    this.formAgenda.controls.responsableMedicoMatricula.setValue(this.agenda?.responsableMedicoMatricula);
    this.formAgenda.controls.responsableMedicoTelefono.setValue(this.agenda?.responsableMedicoTelefono);
    this.formAgenda.controls.responsableMedicoMail.setValue(this.agenda?.responsableMedicoMail);
  }


  goBack(ruta?) {
    if (this.formAgenda.dirty) {
      this.confirm(ruta);
    } else {
      this.returnToAgendas();
    }
  }

  confirm(ruta?) {
    this.confirmationService.confirm({
      header: `¿Está seguro de que desea cancelar la carga de la agenda?`,
      message: `Si cancela la agenda ahora perderá toda la información cargada hasta el momento`,
      key: 'goBackFormEC',
      accept: () => {
        this.returnToAgendas();
      },
    });
  }

  returnToAgendas() {
    this.route.navigate(['agendas'], { queryParams: { page: this.currentPage }});
  }

  getAttachedFiles(event: any): any {
    const { errors } = event;

    this.attachedFiles = event;
    if (errors.isSizeValid && errors.isTypeValid) {
      // asigno la data al objeto para enviar
      return false;
    }
  }

  async onSubmit(): Promise<any> {
    this.submitted = true;
    if (this.formAgenda.invalid || this.attachedFiles.invalid) {
      this.navigateInvalidField('ng-invalid');
      return;
    }
    this.enviandose = true;
    if (this.isOnline) {
      this.save();
    }
  }

  private navigateInvalidField(classFocus: string): void {
    const invalidFields = [].slice.call(
      document.getElementsByClassName(classFocus)
    );
    const field = invalidFields[1];
    field.scrollIntoViewIfNeeded();
    field.focus();
  }

  private save(): void {
    this.agendasService.saveAgenda(this.buildRequest())
      .subscribe(
        (response) => {
          this.openSuccessAlert(response.message, 'agenda');
        },
        (error) => {
          this.formatResponseAndOpenError(error);
        }
      );
  }

  buildRequest() {
    let agendaFormData = { ...this.formAgenda.getRawValue() };
    agendaFormData.idLote = this.agenda.idLote;
    agendaFormData.fechaInicio = this.agenda.fechaInicio;
    agendaFormData.fechaFin = this.agenda.fechaFin;
    agendaFormData.adjuntos = this.attachedFiles.data;
    return agendaFormData;
  }

  private openSuccessAlert(message: string, key: string): void {
    this.enviandose = false;
    this.messageAlertServices.setMessage(0, {
      severity: 'success',
      summary: '',
      detail: message,
      key: key,
    });
    setTimeout(() => {
      this.returnToAgendas();
    }, 500);
  }

  formatResponseAndOpenError(error) {
    let message = error.error.message + ' ';
    message = message + error.error.errors.map((x) => {
      return x;
    }).join(' ');
    this.openErrorAlert(message, 'agenda');
  }

  private openErrorAlert(message: string, key: string): void {
    this.messageAlertServices.setMessage(0, {
      severity: 'error',
      summary: '',
      detail: message,
      key: key,
    });
    setTimeout(() => {
      const header = document.querySelector('#templateContainer') as any;
      window.scroll(0, header.offsetTop - 150);
    }, 100);
    this.enviandose = false;
  }

}
